import React, { useEffect } from 'react';

const TermsOfService: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);  
  return (
    <div className="min-h-screen bg-lunar-gradient py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-lunar-800/50 backdrop-blur-sm rounded-2xl p-8 border border-[var(--primary-color-800-30)]">
          <div className="space-y-8 text-lunar-300">
            <div>
              <h1 className="text-3xl font-bold text-white mb-4">
                Пользовательское соглашение
              </h1>
              <p className="text-sm text-lunar-400">
                Последнее обновление: 15 октября 2025 г. в 11:16
              </p>
            </div>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">Лицензионное соглашение</h2>
            
            <div className="space-y-4 mb-8">
              <p className="text-lunar-300">
                Настоящее лицензионное соглашение (далее — «Соглашение») заключается между пользователем (далее — «Пользователь») и {process.env.REACT_APP_COMPANY_NAME} (далее — «Правообладатель») относительно использования программы для ЭВМ «{process.env.REACT_APP_COMPANY_NAME}» (далее — «Программа»).
              </p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Общие положения</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>1.1.</strong> Стороны Соглашения: Пользователь — физическое или юридическое лицо, использующее Программу; Правообладатель — {process.env.REACT_APP_COMPANY_NAME}.</p>
              <p><strong>1.2.</strong> Способы использования: Пользователь может использовать Программу путем ее воспроизведения и запуска в целях функционирования на технических средствах Пользователя.</p>
              <p><strong>1.3.</strong> Условия использования: Использование Программы допускается только при условии соблюдения всех положений настоящего Соглашения.</p>
              <p><strong>1.4.</strong> Отдельные соглашения: Отдельные функции Программы могут предоставляться на условиях отдельных соглашений.</p>
              <p><strong>1.5.</strong> Функциональность Программы: Программа предназначена для генерации контента с использованием технологий искусственного интеллекта.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Ограничения</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>2.1.</strong> Пользователю запрещается: воспроизводить, распространять, модифицировать, декомпилировать, дизассемблировать Программу или создавать на ее основе производные произведения.</p>
              <p><strong>2.2.</strong> Пользователю запрещается использовать Программу для создания контента, нарушающего законодательство Российской Федерации.</p>
              <p><strong>2.3.</strong> Пользователю запрещается передавать права на использование Программы третьим лицам без письменного согласия Правообладателя.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Правила использования</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>3.1.</strong> Пользователь обязуется использовать Программу исключительно в законных целях и в соответствии с настоящим Соглашением.</p>
              <p><strong>3.2.</strong> Пользователь несет полную ответственность за содержание создаваемого с помощью Программы контента.</p>
              <p><strong>3.3.</strong> Правообладатель не несет ответственности за качество и содержание контента, создаваемого Пользователем.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Возможности сервиса</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>4.1.</strong> Генерация контента с использованием ИИ: Программа предоставляет возможность создания текстового и мультимедийного контента с использованием технологий искусственного интеллекта.</p>
              <p><strong>4.2.</strong> Обработка естественного языка: Программа способна понимать и обрабатывать запросы на естественном языке.</p>
              <p><strong>4.3.</strong> Качественные ответы: Программа стремится предоставлять точные и релевантные ответы на запросы Пользователей.</p>
              <p><strong>4.4.</strong> Базовый и премиум функционал: Программа предоставляет как базовые возможности, доступные всем пользователям, так и расширенные функции для премиум-подписчиков.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Условия использования отдельных функций программы</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>5.1.</strong> Требование доступа к интернету: Для полноценного функционирования Программы требуется стабильное подключение к сети Интернет.</p>
              <p><strong>5.2.</strong> Ограничение доступа: Правообладатель оставляет за собой право ограничить или приостановить доступ к Программе в случае нарушения условий настоящего Соглашения.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Вознаграждение за пользование ограниченным функционалом</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>6.1.</strong> Общие условия: Некоторые функции Программы предоставляются на платной основе в рамках подписочной модели.</p>
              <p><strong>6.2.</strong> Доступ к ограниченному функционалу: Премиум-функции становятся доступными после оплаты соответствующей подписки.</p>
              <p><strong>6.3.</strong> Предоставление доступа: Доступ к платным функциям предоставляется немедленно после подтверждения оплаты.</p>
              <p><strong>6.4.</strong> Бесплатный доступ: Базовый функционал Программы предоставляется бесплатно с определенными ограничениями.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Автоматическое продление подписки</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>7.1.</strong> Подписка автоматически продлевается на следующий период, если Пользователь не отменил ее до окончания текущего периода.</p>
              <p><strong>7.2.</strong> Уведомление о продлении направляется Пользователю не менее чем за 3 дня до списания средств.</p>
              <p><strong>7.3.</strong> Пользователь может отменить автоматическое продление в любое время в настройках аккаунта.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Условия оплаты</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>8.1.</strong> Оплата производится в российских рублях через доступные платежные системы.</p>
              <p><strong>8.2.</strong> Все цены указаны с учетом НДС, если применимо.</p>
              <p><strong>8.3.</strong> Возврат средств осуществляется в соответствии с политикой возврата Правообладателя.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Подписка</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>9.1.</strong> Подписка предоставляет доступ к расширенному функционалу Программы на определенный период.</p>
              <p><strong>9.2.</strong> Период подписки начинается с момента подтверждения оплаты.</p>
              <p><strong>9.3.</strong> По окончании периода подписки доступ к премиум-функциям прекращается.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">10. Тарифы</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>10.1.</strong> Правообладатель предлагает различные тарифные планы с разным набором функций и ограничений.</p>
              <p><strong>10.2.</strong> Актуальная информация о тарифах размещается на официальном сайте Программы.</p>
              <p><strong>10.3.</strong> Правообладатель оставляет за собой право изменять тарифы с уведомлением Пользователей.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">11. Условия изменения условий</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>11.1.</strong> Правообладатель имеет право в любое время изменять условия настоящего Соглашения.</p>
              <p><strong>11.2.</strong> Уведомление об изменениях размещается на официальном сайте не менее чем за 7 дней до вступления изменений в силу.</p>
              <p><strong>11.3.</strong> Продолжение использования Программы после внесения изменений означает согласие с новыми условиями.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">12. Ответственность</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>12.1.</strong> Программа предоставляется «как есть»: Правообладатель не гарантирует бесперебойную работу Программы и не несет ответственности за возможные сбои.</p>
              <p><strong>12.2.</strong> Ограничение ответственности правообладателя: Ответственность Правообладателя ограничивается суммой, уплаченной Пользователем за использование Программы.</p>
              <p><strong>12.3.</strong> Ответственность пользователя: Пользователь несет полную ответственность за соблюдение условий настоящего Соглашения и законодательства.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">13. Обновления и новые версии программы</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>13.1.</strong> Правообладатель может выпускать обновления и новые версии Программы для улучшения функциональности и безопасности.</p>
              <p><strong>13.2.</strong> Обновления могут устанавливаться автоматически или требовать согласия Пользователя.</p>
              <p><strong>13.3.</strong> Использование новых версий регулируется условиями настоящего Соглашения, если не указано иное.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">14. Обработка персональных данных</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>14.1.</strong> Согласие на обработку: Используя Программу, Пользователь дает согласие на обработку своих персональных данных в соответствии с Политикой конфиденциальности.</p>
              <p><strong>14.2.</strong> Действия с персональными данными: Правообладатель обрабатывает персональные данные исключительно в целях предоставления услуг и улучшения качества Программы.</p>
              <p><strong>14.3.</strong> Отзыв согласия: Пользователь может отозвать согласие на обработку персональных данных, обратившись к Правообладателю.</p>
            </div>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">15. Изменения лицензионных условий</h2>
            
            <div className="space-y-4 mb-8">
              <p><strong>15.1.</strong> Односторонние изменения: Правообладатель имеет право в одностороннем порядке изменять условия настоящего Соглашения.</p>
              <p><strong>15.2.</strong> Публикация изменений: Измененные условия публикуются на официальном сайте и вступают в силу с момента публикации, если не указан иной срок.</p>
            </div>

            <div className="mt-12 pt-8 border-t border-[var(--primary-color-800-30)]">
              <div className="text-left">
                <h3 className="text-lg font-semibold text-white mb-4">Контакты для связи</h3>
                <div className="text-lunar-300">
                  <p>Email: {process.env.REACT_APP_SUPPORT_EMAIL || 'support@example.com'}</p>
                  <p>Телефон: {process.env.REACT_APP_SUPPORT_PHONE || '+7 (000) 000-00-00'}</p>
                </div>
                
                <div className="mt-6 text-sm text-lunar-400">
                  <p>{process.env.REACT_APP_COMPANY_NAME || 'Название компании'}</p>
                  <p>ИНН: {process.env.REACT_APP_COMPANY_INN || '000000000000'}</p>
                  <p>ОГРН: {process.env.REACT_APP_COMPANY_OGRN || '000000000000000'}</p>
                  <p>{process.env.REACT_APP_COMPANY_ADDRESS || 'Адрес компании'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;